import React from "react"
import { useState } from "react"

const Home = () => {
	const [isVisible, setstate] = useState(false)

	const toggleVisible = () => {
		setstate(!isVisible)
	}
    
	return (
        <div className="hidden md:flex justify-center mt-12">
            <div className="flex items-center">
                <div className="pb-4 text-blue-400">
                    <h1 className="text-2xl">Hi, I'm</h1>
                    <h1 className="text-8xl pl-4 font-bold">Benedictus</h1>
                    <h1 className="text-8xl pl-4 font-bold">Visto Kartika</h1>
                </div>
            </div>
        </div>
        
	)
}

export default Home
